import React from 'react'

export default function RingingBell(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id='mask0_10440_5760'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'
      >
        <rect width='16' height='16' fill='currentColor' />
      </mask>
      <path
        d='M1.3335 6.66678C1.3335 5.55567 1.58072 4.53622 2.07516 3.60844C2.56961 2.68067 3.2335 1.91122 4.06683 1.30011L4.85016 2.36678C4.1835 2.85567 3.65294 3.47233 3.2585 4.21678C2.86405 4.96122 2.66683 5.77789 2.66683 6.66678H1.3335ZM13.3335 6.66678C13.3335 5.77789 13.1363 4.96122 12.7418 4.21678C12.3474 3.47233 11.8168 2.85567 11.1502 2.36678L11.9335 1.30011C12.7668 1.91122 13.4307 2.68067 13.9252 3.60844C14.4196 4.53622 14.6668 5.55567 14.6668 6.66678H13.3335ZM2.66683 12.6668V11.3334H4.00016V6.66678C4.00016 5.74455 4.27794 4.92511 4.8335 4.20844C5.38905 3.49178 6.11127 3.02233 7.00016 2.80011V2.33344C7.00016 2.05567 7.09738 1.81955 7.29183 1.62511C7.48627 1.43067 7.72238 1.33344 8.00016 1.33344C8.27794 1.33344 8.51405 1.43067 8.7085 1.62511C8.90294 1.81955 9.00016 2.05567 9.00016 2.33344V2.80011C9.88905 3.02233 10.6113 3.49178 11.1668 4.20844C11.7224 4.92511 12.0002 5.74455 12.0002 6.66678V11.3334H13.3335V12.6668H2.66683ZM8.00016 14.6668C7.6335 14.6668 7.31961 14.5362 7.0585 14.2751C6.79739 14.014 6.66683 13.7001 6.66683 13.3334H9.3335C9.3335 13.7001 9.20294 14.014 8.94183 14.2751C8.68072 14.5362 8.36683 14.6668 8.00016 14.6668ZM5.3335 11.3334H10.6668V6.66678C10.6668 5.93344 10.4057 5.30567 9.8835 4.78344C9.36127 4.26122 8.7335 4.00011 8.00016 4.00011C7.26683 4.00011 6.63905 4.26122 6.11683 4.78344C5.59461 5.30567 5.3335 5.93344 5.3335 6.66678V11.3334Z'
        fill='currentColor'
      />
    </svg>
  )
}
